import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import React, {useEffect, useState} from "react";
import styles from './CustomerInfoModal.module.scss'
import EvoDetails from "./EvoDetails";
import {CustomerDTO} from "../../types/CustomerDTO";

function CustomerInfoModal(props: {selectedCustomer: CustomerDTO, handleClose: Function}) {

    const [loading, setLoading] = useState<string|boolean>(false);
    const [evoDetailsVisible, setEvoDetailsVisible] = useState(false);
    
    let content;
    if (loading) {
        content = <Spinner full={true} >{loading}</Spinner>;
    }
    else {
        content =
            <Modal
                visible={!!props.selectedCustomer}
                accent="purple"
                heading={props.selectedCustomer?.name}
                primaryButtonProps={{buttonStyle: {'display': 'none'}}}
                onCancelButtonClick={() => {
                    props.handleClose();
                }}
                onClose={() => props.handleClose()}
            >
                <div className={styles.CustomerInfoModalButtonContainer}>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'Evo'} onClick={() => setEvoDetailsVisible(true)}/>
                    </div>
                </div>
            </Modal>
    }

    return (
        <>
            {content}
            {evoDetailsVisible ?
                <EvoDetails
                    visible={evoDetailsVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setEvoDetailsVisible(false)}
                /> : undefined
            }
        </>
    )

}

export default CustomerInfoModal;
